import axios from 'axios';
import { getAppStorageItem } from 'src/utils/storageProxy';

const instance = axios.create();
// const instance = axios.create({baseURL: process.env.REACT_APP_API_KEY});
const AUTH_TOKEN = `${getAppStorageItem('token_type')} ${getAppStorageItem('access_token')}`
instance.defaults.maxRedirects = 0
instance.defaults.headers.common.Authorization = AUTH_TOKEN;
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default instance
